export default __webpack_public_path__ + "static/media/radiant-bright-purple-blue.66e29128.jpg";